import { CommonModule } from '@angular/common';
import { httpResource } from '@angular/common/http';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MarkdownModule } from 'ngx-markdown';
import { environment } from '../../../../../environments/environment';
import { INewsArticleListResponseDto } from '../../../../shared/ystm-service-api-types';

@Component({
    selector: 'app-news-next',
    imports: [
        CommonModule,
        MatCardModule,
        MatDividerModule,
        MarkdownModule,
    ],
    templateUrl: './news-next.component.html',
    styleUrls: ['./news-next.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsNextComponent {
  newsResource = httpResource(
    () => ({
      url: `${environment.ystmServiceBaseUrl}/news/public`,
    }),
    { parse: (res: unknown) => (res as INewsArticleListResponseDto) || { newsArticles: [] } }
  );
}
